import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getReport = (params) => httpClient.get(`${ENDPOINT_API.REPORTS}`, { params });
const getStockReport = () => httpClient.get(`${ENDPOINT_API.REPORTS}/all-available-stock`);
const getExportReport = async (params) => {
	const dateTime = dayjs().format('YYYY-MM-DD_HH-mm-ss');
	const { data } = await httpClient.get(`${ENDPOINT_API.REPORTS}/export-excel`, {
		responseType: 'blob',
		params,
	});

	saveAs(data, `stock-report-${dateTime}`);
};

export {
	getReport,
	getStockReport,
	getExportReport,
};
